import script from "./VueCookieComply.vue?vue&type=script&setup=true&lang=js"
export * from "./VueCookieComply.vue?vue&type=script&setup=true&lang=js"

import "./VueCookieComply.vue?vue&type=style&index=0&id=643c0e74&lang=scss"

const __exports__ = script;

export default __exports__